// Δήλωση Στοιχείων Σημείου Συλλογής απο τον Χρήστη του

import { gql, useMutation } from '@apollo/client';
import { promiseModalCollectionPointInput } from 'shared-pages/components';
import { useTranslation } from 'react-i18next';
import { isRebatteryLiion } from 'shared-pages/common/constants';

const gqlUpdate = gql`
  mutation updateUser($data: UserInput) {
    updateUser(data: $data) {
      id
    }
  }
`;

export const useDeclareCollectionpoint = () => {
  const { t } = useTranslation();
  const [updateRecord] = useMutation(gqlUpdate);

  const declareCollectionpoint = async ({ userId }) => {
    const cpId = await promiseModalCollectionPointInput({
      title: t('Δήλωση Νέου Σημείου Συλλογής'),
      initialValues: isRebatteryLiion ? {categoryId:2 /* Συνεργείο */} :{}
    });
    if (cpId) {
      console.log('New Collection Point', cpId);
      const ret = updateRecord({ variables: { data: { referenceId: cpId, id: userId } } })
        .then((d) => {
          return true;
        })
        .catch((error) => {
          return false;
        });
      return ret;
    }
    return false;
  };
  return { declareCollectionpoint };
};
